module.exports = global.config = {
  host: "https://api-gateway.sampangkab.go.id/be-damkarpd",
  subdomain: "damkarpd",
};
